var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Active"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Active",
    clipPath: "url(#clip-Active)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3400",
    "data-name": "Group 3400",
    transform: "translate(13231.705 5074.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2543",
    "data-name": "Path 2543",
    d: "M76.17,13.961,69.726,20.4a.634.634,0,0,1-.916-.03l-2.723-3.106",
    transform: "translate(-13292.835 -5082.113)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 9.034,
    cy: 9.034,
    r: 9.034,
    transform: "translate(-13230.739 -5073.874)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/Active.09b97c82aa248298f56a8cc60a4cda3b.svg";
export { ForwardRef as ReactComponent };